import { Column, Columns, Flex, Text } from "@dna/react";
import { FlatButton } from "../common/FlatButton";
import styles from "./SelectOrganisation.module.scss";
import ErrorIcon from "@material-ui/icons/Error";
import { handleSignOut } from "../common/handleSignOut";

export const SelectOrganisationError = () => {
  
  const logOut = () => {
    handleSignOut({reason: "Link user error", url: window.location.href})
  };

  return (
    <div className={styles.background}>
      <div className={styles.innerError}>
        <Flex
          css={{
            gap: "small",
            padding: "small",
          }}
        >
          <div className={styles.contentError}>
            <Columns
              css={{
                gap: "small",
              }}
            >
              <Column width="content">
                <ErrorIcon className={styles.error} />
              </Column>
              <Column width="content">
                <div className={styles.headerError}>
                  There was a problem signing into <br /> MedPoint
                </div>
              </Column>
            </Columns>
            <Columns
              css={{
                gap: "small",
              }}
            >
              <Column width="content">
                <div className={styles.bodyError}>
                  We have experienced an issue signing you into MedPoint.
                </div>
              </Column>
            </Columns>
          </div>

          <hr className={styles.divider} />
          <FlatButton
            type="button"
            kind="primary"
            css={{
              width: 104,
              alignSelf: "flex-end",
            }}
            onPress={logOut}
          >
            OK
          </FlatButton>
        </Flex>
      </div>
    </div>
  );
}
